import { CommonModule } from "@angular/common";
import { Component, OnChanges, Input, HostBinding } from "@angular/core";
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import * as icons from 'src/app/services/icon.library';

@Component({
    selector: 'icon',
    imports: [MatIconModule, CommonModule],
    template: `<mat-icon [title]="title" [ngStyle]="{ transform: 'rotate(' + rotate + 'deg)' }" [attr.aria-label]="(icon ? icon : matIcon)" [svgIcon]="icon">{{matIcon}}</mat-icon><ng-content></ng-content>`,
    styles: [`
        :host { display: inline-flex; justify-content: center; width: 24px; height: 24px; font-size: 24px; align-items: center }
        :host.i12 { width: 12px !important; height: 14px !important; font-size: 12px !important; }
        :host.i15 { width: 15px !important; height: 15px !important; font-size: 15px !important; }
        :host.i18 { width: 18px !important; height: 18px !important; font-size: 18px !important; }
        mat-icon { height:100%; width:100%; font-size: inherit; pointer-events: none; }
    `],
    standalone: true
})
export class IconComponent implements OnChanges {

    @Input() icon;
    @Input() title
    @Input() matIcon;
    @Input() rotate = 0;
    @HostBinding('class.i12') @Input() i12
    @HostBinding('class.i18') @Input() i18
    @HostBinding('class.i15') @Input() i15

    constructor(private iconReg: MatIconRegistry, private sanitizer: DomSanitizer) {}

    ngOnChanges() {
        if (this.matIcon) {
            this.icon = undefined;
            return;
        }
        const icon = this.icon.toUpperCase()
        if(icons[icon]) {
            this.iconReg.addSvgIconLiteral(
                this.icon,
                this.sanitizer.bypassSecurityTrustHtml(icons[icon])
            );
            return;
        }
        this.iconReg.addSvgIcon(
            this.icon,
            this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/' + this.icon + '.svg')
        );
    }
}
